import { render } from "./indexPage.vue?vue&type=template&id=7d3a9540"
import script from "./indexPage.vue?vue&type=script&lang=js"
export * from "./indexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__